<template>
	<div class="hello">
		<div style="width: 35%;">
			<img src="/images/shakeImg/qiantong.png" :class="[{'r1': shrinkPacket}, {'r2': !shrinkPacket}]" style="width: 100%;height: auto;" />
		</div>
		<div v-if="isBtn" @click="shouQuan" style="width: 35%;margin-top: 5%;">
			<img style="width: 100%;height: auto;" src="/images/shakeImg/start.png" />
		</div>
	</div>
</template>

<script>
	import Shake from 'shake.js'
	import request from '../../../common/request.js'
	import axios from 'axios'
	let myVar
	let audio1
	let audio2

	export default {
		name: 'shakeView',
		props: {
			msg: String,
			openid: String,
		},
		data() {
			return {
				shrinkPacket: true,
				value: 1,
				isBtn: true,
			}
		},
		mounted() {
			let that = this
			audio1 = new Audio()
			audio2 = new Audio()
			audio1.src = "https://www.lfwellness.cn/images/shakeImg/yao.mp3"
			audio2.src = "https://www.lfwellness.cn/images/shakeImg/yao.mp3"
			document.body.appendChild(audio1)
			document.body.appendChild(audio2)
			// console.log('navigator', navigator.appVersion)
			//android终端
			if (navigator.appVersion.indexOf('Android') != -1) {
				//android
				that.isBtn = false;
				setTimeout(()=>{
					that.ShakeFoin()
				},1000)
				let myShakeEvent = new Shake({
					threshold: 1, //摇动阈值
					timeout: 500, //事件发生频率
				})

				myShakeEvent.start();
				window.addEventListener('shake', that.shakeEventDidOccur, false)
			} else {
				//ios
				this.shouQuan();
			}

		},
		methods: {
			shouQuan() {
				let that = this
				if (typeof DeviceMotionEvent.requestPermission === 'function') {
					DeviceMotionEvent.requestPermission()
						.then(permissionState => {
							if (permissionState === 'granted') {
								that.isBtn = false;
								that.ShakeFoin()
								let myShakeEvent = new Shake({
									threshold: 1, //摇动阈值
									timeout: 500, //事件发生频率
								})

								myShakeEvent.start();
								window.addEventListener('shake', that.shakeEventDidOccur, false);
							} else {
								that.isBtn = true;
							}
						}).catch(console.error);
				} else {
					// alert('本机无DeviceMotionEvent')
				}
			},
			shakeEventDidOccur() {

				clearTimeout(myVar)

				let that = this
				that.shrinkPacket = !that.shrinkPacket
				that.value++


				if (that.value % 10 == 0) {
					that.ShakeFoin()
				} else {
					myVar = setTimeout(() => {
						that.ShakeFoin()
					}, 3000)
				}

				if (audio1.currentTime > 3) {
					audio1.pause()
					audio2.play();
					audio1.currentTime = 1
				} else {
					audio2.pause()
					audio1.play();
					audio2.currentTime = 1
				}

			},
			ShakeFoin() { //摇一摇发送信息

				let that = this
				let data = {
					"u_open_id": that.openid,
					"roll_nums": that.value ? that.value : 2,
				}

				let requests = request.getQueryData(data || {})

				axios.post('https://test.lfwellness.cn/api_erp/Meting/go_roll',
					requests).then(function(data) {
					// console.log('data', data)
					if (data.data) {
						if (data.data.ResultCode === 200) {

							that.value = 0

						} else if (data.data.ResultCode === 123) {

						} else {
							that.$emit('data-info', data.data)

						}
					} else {
						that.value = 0
					}

				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.hello {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.r1 {
		transform: rotateZ(30deg);
	}

	.r2 {
		transform: rotateZ(-30deg);
	}
</style>
